(() => {
function initialize(container=document) {
 container.querySelectorAll('[data-ohsip-home]').forEach(root => {
  if(root.dataset.initialized) return;
  root.dataset.initialized='true';
const moods = {
  hot: {number:'01 / HOT COFFEE', title:'ONE CUBE. A WARM CUP.', detail:'Drop a cube into hot water and stir until dissolved. No filter or grounds to clear away.', image:root.dataset.hotImage, alt:'Concept serving scene: hot black coffee in a cream ceramic mug, in sunlight on a purple table', caption:'NO SCOOP. NO MEASURING.'},
  iced: {number:'02 / ICED COFFEE', title:'ICE WATER IN. COFFEE OUT.', detail:'Drop a cube straight into ice water and stir, or close your shaker and shake until dissolved. No hot water needed.', image:root.dataset.icedImage, alt:'Concept serving scene: iced black coffee with clear ice and condensation on an ice-blue table', caption:'MELTS IN ICE WATER.'},
  latte: {number:'03 / ICED LATTE', title:'COFFEE FIRST. THEN MILK.', detail:'Dissolve a cube in a little ice water, then pour in your favorite milk.', image:root.dataset.latteImage, alt:'Concept serving scene: iced latte with coffee and milk swirls on a sunlit metal tray', caption:'ONE CUBE. YOUR MILK.'}
};
root.querySelectorAll('[data-mood]').forEach(button => button.addEventListener('click', () => {
  const key = button.dataset.mood;
  const mood = moods[key];
  root.querySelectorAll('[data-mood]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
  root.querySelector('.mood-panel').dataset.style = key;
  root.querySelector('#mood-number').textContent = mood.number;
  root.querySelector('#mood-title').textContent = mood.title;
  root.querySelector('#mood-detail').textContent = mood.detail;
  root.querySelector('#mood-caption').textContent = mood.caption;
  const photo = root.querySelector('#mood-photo');
  photo.src = mood.image;
  photo.alt = mood.alt;
}));
root.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => {
  root.querySelectorAll('[data-image]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
  const image = document.createElement('img');
  const target = root.querySelector('#shop-image');
  if (button.dataset.image === 'cube') {
    image.src = root.dataset.cubeImage; image.alt = 'OHSIP coffee cube close-up'; image.className = 'cube-detail'; target.replaceChildren(image);
  } else {
    image.src = root.dataset.bagImage; image.alt = 'OHSIP 30-cube packaging front';
    const pack = document.createElement('div'); pack.className = 'pack'; pack.append(image); target.replaceChildren(pack);
  }
}));
 });
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initialize()); else initialize();
document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
